<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute">
        <img class="box-img" src="../assets/banner2.png" />
        <div class="box-font">注册中心</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px">
      <div id="xieyi" style="margin-left: 20px; padding: 20px; margin-top: 20px; border: 1px solid #cccccc" v-if="!isShow">
        <table border="0" align="center" cellpadding="0" cellspacing="0">
          <tr>
            <td height="44" align="center">
              <font style="font-size: 16px; font-weight: bold">供应商注册协议</font>
            </td>
          </tr>
          <tr>
            <div v-html="content"></div>
            <!-- <td style="line-height:130%; font-size:14px;">
              <p>优胜电子采购平台服务条款 <br>
                <strong>请仔细阅读本协议</strong> <br>
                福建盛鑫招标代理有限公司（下称“本公司”）依据以下条件和条款提供您所享有的服务。 <br>
                本协议阐述之条款和条件适用于您使用优胜网上竞价平台（下称“本平台”），参与政府采购竞价招标业务进行投标和交流的各种工具和服务(下称“服务”)，视同双方的书面协议： <br>

                一、
                以任何方式进入本平台即表示您同意自己已经与本公司订立本协议，且您将受本协议的条款和条件约束。本平台可随时自行全权决定更改“条款”。如“条款”有任何变更，将在网站上刊载公告，通知予您。如您不同意相关变更，必须停止使用“服务”。经修订的“条款”一经网站的公布后，立即自动生效。您应在第一次登录后仔细阅读修订后的“条款”，并有权选择停止继续使用“服务”；一旦您继续使用“服务”，则表示您已接受经修订的“条款”，当您与本公司发生争议时，应以最新的服务协议为准。除另行明确声明外，任何使“服务”范围扩大或功能增强的新内容均受本协议约束。除非经本公司的授权高层管理人员签订书面协议，本协议不得另行作出修订。
                <br>
                二、“服务”仅供能够根据相关法律订立具有法律约束力的合约的公司使用。因此，您的公司必须是经国家部门注册登记的独立法人企业，才可使用本公司服务。如不符合本项条件，请勿使用“服务”。本平台可随时自行全权决定拒绝向不合法企业会员提供“服务”。
                <br>
                本协议甲方为“优胜电子采购平台”（简称平台）的提供者，乙方为卖方会员（供应商），双方经共同协商，就乙方使用本平台开展服务达成一下协议。<br>
                <strong>三、平台内容</strong><br>
                1、平台定义：优胜电子采购平台是由福建优胜科技有限责任公司建设提供的用于网上执行招投标业务的平台。<br>
                2、会员及会员注册：会员注册是指会员登陆平台，并按要求填写相关信息并确认相关会员协议的过程。会员因进行交易、获取有偿服务或接触平台服务而发生的所有应纳税赋，以及一切硬件、软件、服务及其他方面的费用均由会员负责支付。平台仅作为会员就货物和服务的交易进行投标、协商，以及获取各类与贸易相关的服务的地点。<u>
                </u><br>
                <strong>四、平台的权利和义务：</strong><br>
                1、有义务在现有技术上确保整个电子采购平台的正常运行，并努力提升和改进技术，保证会员网上交易活动的顺利。有权对会员的注册资料及交易行为进行查阅，发现注册资料或交易行为中存在任何问题或怀疑，均有权向会员发出询问及要求改正的通知并作出删除等处理。
                <br>
                2、就平台的使用对会员进行指导培训，对会员在使用平台中所遇到的问题及反映的情况，有义务及时作出回复并解决。 <br>
                3、有权就平台提供的服务按功能模块收取服务费，并有权对服务费标准进行调整而不需会员同意，同时保留会员已缴纳费用的期间段的服务，新标准从下一期间段开始。您授予本公司独家的、全球通用的、永久的、免费的许可使用权利
                (并有权在多个层面对该权利进行再授权)，使本公司有权(全部或部份地)
                使用、复制、修订、改写、发布、翻译、分发、执行和展示&quot;您的资料&quot;或制作其派生作品，和/或以现在已知或日后开发的任何形式、媒体或技术，将&quot;您的资料&quot;纳入其他作品内。 <br>
                4、经政府部门通知已被取消经营资格的，优胜科技有权通知会员后作出删除相关信息、终止服务直至取消会员资格等处理，而无须征得会员的同意。 <br>
                5、会员在服务过程中产生纠纷，.经政府主管部门生效法律文书要求优胜科技从中予以配合，优胜科技有义务向主管部门提供相应资料而无须征得会员的同意。 <br>
                6、本平台不能控制交易所涉及的物品的质量、安全或合法性，商贸信息的真实性或准确性，以及交易方履行其在贸易协议项下的各项义务的能力。本平台不会就通过“服务”传送的任何资料的准确性、有用性或可用性、可获利性负责或承担任何责任，且不会对根据该资料而作出的任何交易或投资决策负责或承担任何责任。对于会员发布的与平台所提供的服务无关的信息，同时有足够理由相信该信息违反公共利益或可能严重损害其他会员合法利益的，优胜科技有权在通知会员的前提下进行删除或采取其他限制性措施。
                <br>
                <strong>五、会员的权利和义务</strong><br>
                1、会员有权利拥有自己的用户名及密码，并有权利使用自己的用户名及密码随时登陆优胜电子采购平台，参加中介机构在本平台上进行的招投标业务。会员不得以任何形式擅自转让或授权他人使用自己的会员名。会员对本单位所申请的帐号和密码安全负全部责任，由于他人原因造成自己的账号和密码外泄并由此造成的损失和责任我公司免负责，如用户名或密码丢失被盗，应立即通知运营者，由运营者管理员取消原密码并重新设置新密码。
                <br>
                2、会员有义务在注册时提供自己的真实资料，并保证诸如电子邮件地址、联系电话、联系地址、邮政编码等内容的有效性及安全性，同时向平台提交必要的合法企业证明。同时，会员也有义务在相关资料实际变更时及时更新有关注册资料。会员保证不以他人资料在优胜采购平台进行注册或认证。
                <br>
                3、会员有权根据本服务协议的规定以及平台上发布的相关规则发布、修改物品信息、参加网上物品竞卖、参加有关活动以及有权享受平台提供的其他的有关信息服务，并保证所发布的信息真实有效。会员承诺自己在使用优胜采购平台时的所有行为遵守国家法律、法规和平台的相关规定以及各种社会公共利益或公共道德。用户对其所发布的内容单独承担全部责任。对平台服务的使用必须依据所有适用于互联网服务的国家法律、地方法令和国际法规的标准。用户必须承诺：
                <br>
                （1）不传输任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、淫秽的信息资料。 <br>
                （2）不传输任何教唆他人构成犯罪行为的资料。 <br>
                （3）不传输助长国内不利条件和涉及国家安全的资料。 <br>
                （4）不传输其它任何不符合国家法律和国际法律的资料。 <br>
                （5）注册用户对其发布的信息负责，不得发布失实的、有歧视的信息 。 <br>
                （6）注册用户如违反1、2、3、4、5条规定造成福建盛鑫招标代理有限公司经济损失，福建盛鑫招标代理有限公司有权追究其经济责任与法律责任。 <br>
                4、会员使用本平台进行服务发生的所有应纳税赋，以及相关硬件、软件、服务及其他方面的费用均由会员自行负责。 <br>
                <strong>六、费用及结算 </strong><br>
                1、会员参加中介机构在本平台上进行的招投标业务，根据中介机构的要求缴纳费用，本平台不另行收取费用。 <br>
                2、会员加入网上商城或使用其它服务，使用各项功能需缴纳会员服务费。<strong> </strong><br>
                <strong>七、</strong><strong>服务的中断和终止</strong><strong> </strong><br>
                &nbsp;&nbsp;&nbsp;
                1、会员同意，在未收取服务费的情况下，平台可自行全权决定终止会员的密码、帐号和服务，并删除和丢弃会员资料。同时可自行全权决定，在发出通知或不发出通知的情况下，随时停止提供服务或其任何部份。帐号终止后，平台没有义务为您保留与之相关的任何信息，不会就终止服务而对您或任何第三者承担任何责任。
                <br>
                &nbsp;&nbsp;&nbsp;
                2、会员向平台提出注销会员身份，经平台确认双方无任何经济纠纷后，由平台注销注册会员，会员即解除服务协议关系；平台发现会员注册资料中主要内容是虚假的，经通知不及时修正的，平台可以随时单方面终止与该会员的服务协议，所缴纳费用不予退还。但注销会员后，商城有权保留会员的注册资料及以前的交易行为记录。
                <br>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3.&nbsp;&nbsp;&nbsp;本服务协议终止或更新时，会员未确认新的服务协议的，视为双方自动解约。 <br>
                <strong>八、免责条款</strong> <br>
                1、您明确理解和同意，本公司不对因下述任一情况而发生的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其他无形损失的损害赔偿： <br>
                （1）甲方预先通知进行服务器配置、维护时需要短时间中断服务，或者由于Internet 通路的阻塞，或因Y2K问题、黑客、病毒、技术调整等引起的事件，由此造成的服务器访问速度下降或任何形式的数据丢失； <br>
                （2）遇有不能预见、不能避免或不能克服的客观事件，包括但不限于自然灾害（如洪水、火灾、爆炸、雷电、地震和风暴等）以及社会事件(如战争、动乱、政府管制、生产线变更、国家政策的突然变动和罢工等)。 <br>
                （3）您同意，因您违反本协议或经在此提及而纳入本协议的其他文件，或因您违反了法律或侵害了第三方的权利，第三方向任何一方提出的索赔要求（包括司法费用和其他专业人士的费用）自行负责，与平台无关。
              </p>
            </td> -->
          </tr>
          <tr>
            <td height="28">
              <div align="center"><input type="radio" @click="Accept" value="1" />接受协议</div>
            </td>
          </tr>
          <tr>
            <td height="60">
              <div align="center" id="but1" style="display: ">
                <el-button type="primary" disabled>开始注册</el-button>
              </div>
              <div align="center" id="but2" style="display: none">
                <el-button type="primary" @click="start">开始注册</el-button>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <!-- ; display: none -->
      <div id="reg" style="margin-left: 20px; padding: 20px; margin-top: 20px; border: 1px solid #cccccc" v-else>
        <h3 style="font-size: 16px; padding-top: 30px; font-weight: bold; text-align: center">卖方(供应方)注册</h3>
        <el-form ref="infoForm" :model="infoForm" :rules="rules" label-width="135px">
          <el-row align="middle" class="warp">
            <!-- <el-col class="warp-main">
              <el-form-item label="类别：">
                <span>卖方(供应方)注册</span>
              </el-form-item>
            </el-col> -->
            <el-col>
              <el-form-item label="用户名：" trigger="blur" prop="LoginName">
                <el-input v-model="infoForm.LoginName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="密码：" trigger="blur" prop="LoginPWD">
                <el-input show-password minlength="6" v-model="infoForm.LoginPWD"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="确认密码：" trigger="blur" prop="ConfirmPWD">
                <el-input show-password minlength="6" v-model="infoForm.ConfirmPWD"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="密码问题：">
                <el-input v-model="infoForm.SecurityQuestion"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="密码答案：">
                <el-input v-model="infoForm.SecretAnswer"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="用户类型：" trigger="blur" prop="RegisterType">
                <el-radio v-model="infoForm.RegisterType" label="0">一般供货商</el-radio>
                <el-radio v-model="infoForm.RegisterType" label="1">协议供货商</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="用户角色：">
                <el-radio v-model="infoForm.RegisterRole" label="1">询价</el-radio>
                <el-radio v-model="infoForm.RegisterRole" label="2">竞价</el-radio>
              </el-form-item>
            </el-col> -->
            <el-col :span="8">
              <el-form-item label="地区：">
                <el-input v-model="infoForm.sheng"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="省" label-width="30px">
                <el-input v-model="infoForm.shi"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="地市" label-width="50px">
                <el-input v-model="infoForm.xian"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-form-item label="县/市" label-width="50px"> </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位名称：" trigger="blur" prop="CompanyName">
                <el-input v-model="infoForm.CompanyName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地址：" trigger="blur" prop="Address">
                <el-input v-model="infoForm.Address"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮编：" trigger="blur" prop="PostalCode">
                <el-input v-model="infoForm.PostalCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="网址：">
                <el-input v-model="infoForm.Website"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人：" trigger="blur" prop="Contacts">
                <el-input v-model="infoForm.Contacts"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话：" trigger="blur" prop="Telphone">
                <el-input v-model="infoForm.Telphone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机：" trigger="blur" prop="Phone">
                <el-input v-model="infoForm.Phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="传真：" trigger="blur" prop="Fax">
                <el-input v-model="infoForm.Fax"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="总协调人：">
                <el-input v-model="infoForm.Coordinator"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话：">
                <el-input v-model="infoForm.CoordinatorPhone"></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="email：">
                <el-input v-model="infoForm.Email"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行：" trigger="blur" prop="Bank">
                <el-input v-model="infoForm.Bank"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="帐号：" trigger="blur" prop="BankNO">
                <el-input v-model="infoForm.BankNO"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="营业执照有效期：" trigger="blur" prop="LicenseValid">
                <el-date-picker v-model="infoForm.LicenseValid" type="date" placeholder="选择日期"> </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="营业执照号码：" trigger="blur" prop="LicenseNO">
                <el-input v-model="infoForm.LicenseNO"></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="营业执照：" trigger="blur" prop="Upload_1">
                <el-upload
                  class="upload-demo"
                  action=""
                  ref="Pic_Upload_1"
                  :http-request="Pic_Upload_1"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-success="handleAvatarSuccess"
                  name="Files"
                  accept=".jpeg,.png,.jpg,.gif,.BMP"
                  :limit="1"
                  :file-list="fileList"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">(文件大小&lt;200k 格式.jpg或.gif)</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="法人代表身份证：" trigger="blur" prop="Upload_4">
                <el-upload
                  class="upload-demo"
                  action=""
                  ref="Pic_Upload_4"
                  :http-request="Pic_Upload_4"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-success="handleAvatarSuccess2"
                  name="Files"
                  accept=".jpeg,.png,.jpg,.gif,.BMP"
                  :limit="1"
                  :file-list="fileList"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">(文件大小&lt;200k 格式.jpg或.gif)</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="其他附件：">
                <el-upload
                  class="upload-demo"
                  action=""
                  :http-request="file_Upload_5"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-success="handleAvatarSuccess3"
                  name="Files"
                  accept=".zip,.rar,.cab,.doc"
                  :limit="1"
                  :file-list="fileList"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">(大小&lt;1M 格式.zip.rar.cab.doc)</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-input type="textarea" :rows="5" placeholder="请输入备注" v-model="infoForm.Remark"> </el-input>
          </el-row>
        </el-form>
        <div style="text-align: center; padding-top: 20px">
          <el-button type="primary" @click="submit">提 交</el-button>
          <el-button type="primary" @click="reset">重 置</el-button>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "Register",
  components: {},
  data() {
    return {
      fileList: [],
      infoForm: {},
      rules: {
        LoginName: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        LoginPWD: [{ required: true, message: "请输入密码", trigger: "blur" }],
        ConfirmPWD: [{ required: true, message: "请输入确认密码", trigger: "blur" }],
        RegisterType: [{ required: true, message: "请选择用户类型", trigger: "blur" }],
        CompanyName: [{ required: true, message: "请输入单位名称", trigger: "blur" }],
        Address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        PostalCode: [{ required: true, message: "请输入邮编", trigger: "blur" }],
        Contacts: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        Telphone: [{ required: true, message: "请输入电话", trigger: "blur" }],
        Phone: [{ required: true, message: "请输入手机", trigger: "blur" }],
        Fax: [{ required: true, message: "请输入传真", trigger: "blur" }],
        Bank: [{ required: true, message: "请输入开户行", trigger: "blur" }],
        BankNO: [{ required: true, message: "请输入帐号", trigger: "blur" }],
        LicenseValid: [{ required: true, message: "请选择营业执照有效期", trigger: "blur" }],
        LicenseNO: [{ required: true, message: "请输入营业执照号码", trigger: "blur" }],
        Upload_1: [{ required: false, message: "请上传营业执照", trigger: "blur" }],
        Upload_4: [{ required: false, message: "请上传法人代表身份证", trigger: "blur" }],
      },
      content: "",
      isShow: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      var that = this;
      this.$api.get("/Column/131", null, (r) => {
        that.content = r.response.Content;
      });
    },
    Accept() {
      but2.style.display = "";
      but1.style.display = "none";
    },
    start() {
      // xieyi.style.display = "none";
      // reg.style.display = "";
      this.isShow = true;
    },
    handleRemove(file, fileList) {
    },
    handlePreview(file) {
    },
    handleAvatarSuccess(res, file) {
      this.infoForm.Upload_1 = res.response;
      this.$refs.infoForm.clearValidate("Upload_1");
    },
    handleAvatarSuccess2(res, file) {
      this.infoForm.Upload_4 = res.response;
      this.$refs.infoForm.clearValidate("Upload_4");
    },
    handleAvatarSuccess3(res, file) {
      this.infoForm.Upload_5 = res.response;
    },
    //清空显示列表
    clearShowList(uid, num) {
      if (num == 1) {
        let idx = this.$refs["Pic_Upload_1"].uploadFiles.findIndex((item) => item.uid === uid);
        this.$refs.Pic_Upload_1.uploadFiles.splice(idx, 1);
      } else {
        let idx = this.$refs["Pic_Upload_4"].uploadFiles.findIndex((item) => item.uid === uid);
        this.$refs.Pic_Upload_4.uploadFiles.splice(idx, 1);
      }
    },
    submit() {
      let _this = this;
      _this.$refs.infoForm.validate((valid) => {
        if (valid) {
          if (_this.infoForm.ConfirmPWD != _this.infoForm.LoginPWD) {
            _this.$message({
              message: "两次输入密码不一致!",
              type: "error",
            });
            return;
          }
          if (_this.infoForm.LoginPWD.length < 6) {
            _this.$message({
              message: "密码长度必须大于等于6位!",
              type: "error",
            });
            return;
          }
          if (!_this.infoForm.Upload_1) {
            _this.$message({
              message: "请上传营业执照!",
              type: "error",
            });
            return;
          }
          if (!_this.infoForm.Upload_4) {
            _this.$message({
              message: "请上传法人代表身份证!",
              type: "error",
            });
            return;
          }
          _this.addLoading = true;
          let para = Object.assign({}, this.infoForm);
          _this.$api.post("/User/Add", para, (res) => {
            console.log(res);
            if (res.success) {
              _this.$message({
                message: "注册成功，请等待审核！",
                type: "success",
              });
              _this.$router.replace("/home");
            } else {
              _this.$message({
                message: res.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    reset() {
      this.infoForm = {};
    },
    Pic_Upload_1(file) {
      this.importFile(file, 1);
    },
    Pic_Upload_4(file) {
      this.importFile(file, 2);
    },
    file_Upload_5(file) {
      if (file.file.size / 1024 / 1024 > 5) {
        this.$message({
          showClose: true,
          message: "上传失败，文件大小请控制在 5M 以内",
          type: "error",
        });
        return;
      }
      var formData = new FormData();
      formData.append("files", file.file);
      var requestConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      this.$api.post(
        "/uploadfile/reg",
        formData,
        (res) => {
          if (res.success) {
            this.$message({
              showClose: true,
              message: "文件上传成功",
              type: "success",
            });
            this.infoForm.upload_5 = res.response;
          } else {
            this.fileList = [];
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
            });
          }
        },
        requestConfig
      );
    },
    importFile(file, num) {
      const isAccord =
        file.file.type === "image/jpeg" ||
        file.file.type === "image/png" ||
        file.file.type === "image/GIF" ||
        file.file.type === "image/jpg" ||
        file.file.type === "image/BMP";
      if (file.file.size / 1024 / 1024 > 2) {
        this.$message({
          showClose: true,
          message: "上传失败，图片大小请控制在 2M 以内",
          type: "error",
        });
        this.clearShowList(file.uid, num);
        return;
      }
      if (file.file.type == isAccord) {
        this.$message({
          showClose: true,
          message: "图片格式错误",
          type: "error",
        });
        this.clearShowList(file.uid, num);
        return;
      }
      var formData = new FormData();
      formData.append("files", file.file);
      var requestConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      this.$api.post(
        "/upload/reg",
        formData,
        (res) => {
          if (res.success) {
            this.$message({
              showClose: true,
              message: "文件上传成功",
              type: "success",
            });
            if (num == 1) {
              this.infoForm.Upload_1 = res.response;
            } else {
              this.infoForm.Upload_4 = res.response;
            }
          } else {
            this.fileList = [];
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
            });
            this.clearShowList(file.uid, num);
          }
        },
        requestConfig
      );
    },
  },
  watch: {
    $route(to) {
      console.log("ooooooooooooo");
      this.list = [];
      this.isShow = true;
      this.page = to.query.page;
    },
  },
  computed: {},
};
</script>

<style>
article.newhome {
  width: 1300px;
}

.el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

input::-webkit-input-placeholder {
  color: #999999;
  padding: 10px 0px 16px 10px;
}

.pagination {
  text-align: center;
}

.frame-border {
  width: 204px;
  border: 1px solid #eeeeee;
}

.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}
</style>
